export default "__VITE_ASSET__sHSSwfrS__"